module.exports = __webpack_public_path__ + "static/media/glowberry.9d253271.webp";